import mixpanel from 'mixpanel-browser';

mixpanel.init('ea5645d885a990da2e8a9c1258fc2edf', {
  debug: false,
  track_pageview: true,
  persistence: 'localStorage',
});

